module.exports = __webpack_public_path__ + "static/img/mp3.a9a51f40.png";